import { SingleSetPromotionBasicState } from "./SingleSetPromotionBasicState";
import { SingleSetPromotionInitState } from "./SingleSetPromotionInitState";
import { SingleSetPromotionStartState } from "./SingleSetPromotionStartState";
import { SingleSetPromotionInProgressState } from "./SingleSetPromotionInProgressState";
import { SingleSetPromotionDisableState } from "./SingleSetPromotionDisableState";
import { SingleSetPromotionStates } from "../SingleSetPromotionStates";

export const SingleSetPromotionStatesMap = {
    [SingleSetPromotionStates.INIT]: SingleSetPromotionInitState,
    [SingleSetPromotionStates.BASIC]: SingleSetPromotionBasicState,
    [SingleSetPromotionStates.START]: SingleSetPromotionStartState,
    [SingleSetPromotionStates.IN_PROGRESS]: SingleSetPromotionInProgressState,
    [SingleSetPromotionStates.DISABLED]: SingleSetPromotionDisableState,
};
